<script setup lang="ts">
  import { Button } from '@ui/components/button';
  import { ButtonGroup } from '@ui/components/button-group';

  const emit = defineEmits<{
    (e: 'approve'): void;
    (e: 'reject'): void;
  }>();
</script>

<template>
  <ButtonGroup class="border w-full">
    <Button class="flex-1" size="sm" @click="emit('approve')">
      <i class="far fa-thumbs-up" />
      Approve
    </Button>

    <Button class="flex-1" size="sm" variant="outline" @click="emit('reject')">
      <i class="far fa-thumbs-down" />
      Reject
    </Button>
  </ButtonGroup>
</template>
